import React from "react";

export interface WeekAvailability {
  dateRange: string;
  bars: { color: string; height: number }[];
}


const Y_LABELS = ["100%", "50%", "25%", "0%"];

export function AvailabilityChart({ week }: { week: WeekAvailability }) {
  return (
    <div className="flex flex-col" style={{ width: 196 }}>
      <div
        className="flex flex-row justify-between"
        style={{ padding: "0 4px", height: 15 }}
      >
        {week.dateRange.split(" - ").map((d, i) => (
          <span
            key={i}
            style={{
              fontFamily: "Poppins",
              fontWeight: 500,
              fontSize: 10,
              color: "#A1A1A1",
            }}
          >
            {d}
          </span>
        ))}
      </div>

      <div className="flex flex-row" style={{ height: 95 }}>
        <div className="flex flex-col" style={{ width: 30, gap: 5 }}>
          {Y_LABELS.map((label) => (
            <div
              key={label}
              className="flex items-end justify-end"
              style={{
                height: 20,
                borderBottom: "1px solid #EAEAEA",
                fontFamily: "Poppins",
                fontWeight: 500,
                fontSize: 10,
                color: "#D9D9D9",
                textAlign: "right",
              }}
            >
              {label}
            </div>
          ))}
        </div>

        <div className="flex-1 relative">
          <div className="absolute inset-0 flex flex-col" style={{ gap: 5 }}>
            {Y_LABELS.map((_, i) => (
              <div
                key={i}
                style={{ height: 20, borderBottom: "1px solid #EAEAEA" }}
              />
            ))}
          </div>

          <div
            className="absolute bottom-0 left-0 right-0 flex flex-row justify-between items-end"
            style={{ height: 95, padding: "0 4px", gap: 10 }}
          >
            {week.bars.map((bar, i) => (
              <div
                key={i}
                style={{
                  width: 21,
                  height: Math.max(bar.height, 3),
                  background: bar.color,
                  boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.15)",
                  borderRadius: 2,
                  margin: "0 auto",
                }}
              />
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
